import React from "react";
import * as TWEEN from "@tweenjs/tween.js";

import lucky_card from "../../../images/gameplay_ui/cards/lucky.png";
export default class GameCardUI extends React.Component
{
    constructor() {
        super();
        this.state = {
            backWidth: 0,
            backHeight: 0,
            frontWidth: 0,
        }
        this.cardBack = null;
        let debugStyle = {
            width: 500,
            height: 500,
            background: "white"
        }
        this.cardWidth = 330;
        this.cardHeight = 500;
        this.contentCard = <div style={debugStyle}>

        </div>
    }
    componentDidMount() {
        this.clearCardState();
    }
    clearCardState()
    {
        this.setState({
            backWidth: 0,
            backHeight: 0,
            frontWidth: 0
        });
        const tweenData = {width: 0, height: 0};
        const tween = new TWEEN.Tween(tweenData).to({width: 1, height: 1}, 250).onUpdate(()=>{
            this.setState({
                backWidth: tweenData.width,
                backHeight: tweenData.height,
            });
        }).start();
    }
    hide(){
        this.props.onHide();
        this.card = null;
    }
    flip(){
        const tweenData = {cover: 1, content: 0};
        const tween = new TWEEN.Tween(tweenData).to({cover: 0, content: 0}, 250).onUpdate(()=>{
            this.setState({
                backWidth: tweenData.cover,
                frontWidth: tweenData.content
            });
        });
        const tween2 = new TWEEN.Tween(tweenData).to({cover: 0, content: 1}, 250).onUpdate(()=>{
            this.setState({
                backWidth: tweenData.cover,
                frontWidth: tweenData.content
            });
        });
        tween.chain(tween2).start();
    }
    render() {
        let styleBack = {
            width: `${ this.cardWidth}px`,
            height: `${this.cardHeight}px`,
            transformOrigin: "center",
            transform:`scale(${this.state.backWidth}, ${this.state.backHeight})`
        }
        let styleFront= {
            position: "absolute",
            left: "0px",
            width: `${ this.cardWidth}px`,
            height: `${this.cardHeight}px`,
            transform:`scale(${this.state.frontWidth}, ${this.state.backHeight})`
        }
        let mainStyle = {
            position: "relative",
            width:  this.cardWidth,
            height:this.cardHeight,
            top: "50%",
            left: "50%",
            transform: "translate(-50%,-50%)"
        }
        if(this.props.card.isLucky){
            this.contentCard =   <img alt={'lucky'} style={styleFront} src={lucky_card} onClick={this.hide.bind(this)}/>
        }


        return <div className="in-game-popup" style={{
            width: this.props.width,
            height: this.props.height,
            background: "rgba(0, 0, 0, 0.5)",
            backdropFilter: "blur(5px)"
        }}>
            <div style={mainStyle}>
                <img alt={'card'} style={styleBack} src={this.cardBack} onClick={this.flip.bind(this)}/>
                {this.contentCard}
            </div>
        </div>
    }
}
